import { render, staticRenderFns } from "./AllowancesReport.vue?vue&type=template&id=559da879"
import script from "./AllowancesReport.vue?vue&type=script&lang=js"
export * from "./AllowancesReport.vue?vue&type=script&lang=js"
import style0 from "./AllowancesReport.vue?vue&type=style&index=0&id=559da879&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports